import api from "api/api";

export const getReasonLeaveList = async () =>
  await api.get("/settings/reason_leave");

export const getReasonLeaveById = async (id) =>
  await api.get(`/settings/reason_leave/${id}`);

export const updateReasonLeaveById = async (id, data) =>
  await api.put(`/settings/reason_leave/${id}`, data);

export const createReasonLeave = async (data) =>
  await api.post("/settings/reason_leave", data);

export const deleteReasonLeaveById = async (id) =>
  await api.delete(`/settings/reason_leave/${id}`);
